import './index.less';
import useFieldCargoOwner from '@/hooks/useFieldCargoOwner';
import { useSelector, useDispatch } from 'react-redux';
import { changeViewRole } from '@/store/user-info';
import ComponentLog from '@/components/component-log';

function ChangeRole() {
  const dispatch = useDispatch();
  const changeRoleText = useFieldCargoOwner('我是场主，切换至货主', '我是货主，切换至场主');
  const hideChangeRoleBtn = useSelector((state) => state.userInfo.hideRoleChangeBtn);
  if (hideChangeRoleBtn) return null;
  return (
    <ComponentLog>
      <div
        /* @ts-ignore */
        clstag="yx_center|workbench_switch2"
        onClick={() => dispatch(changeViewRole())}
        className="change-role-in-platf"
      >
        {changeRoleText}
      </div>
    </ComponentLog>
  );
}

export default ChangeRole;
